import type { ReactNode } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'
import { ShieldAlert } from 'lucide-react'
import { Role } from '@shared/types'
import { Button, EmptyState } from '@/components/ui'
import { useAuthStore } from '@/stores/useAuthStore'

interface RequireAdminProps {
  children: ReactNode
}

export default function RequireAdmin({ children }: RequireAdminProps): React.ReactElement {
  const navigate = useNavigate()
  const user = useAuthStore((state) => state.user)

  if (!user) return <Navigate to="/login" replace />

  // A silent redirect reads as a bug when someone follows a shared /admin link,
  // so say plainly that the account lacks the role.
  if (user.role !== Role.Admin) {
    return (
      <EmptyState
        icon={<ShieldAlert className="h-6 w-6" aria-hidden="true" />}
        title="Admins only"
        description="This area manages users and instance-wide settings. Your account does not have the admin role."
        action={
          <Button variant="secondary" onClick={() => navigate('/sites')}>
            Back to sites
          </Button>
        }
      />
    )
  }

  return <>{children}</>
}

export { RequireAdmin }
